export default "__VITE_ASSET__564d79fc__"